module.exports = __webpack_public_path__ + "static/media/fhbf_interventionsstelle_logo.557aedc0.png";